import { render, staticRenderFns } from "./PackagingDialog.vue?vue&type=template&id=fcb875b8"
import script from "./PackagingDialog.vue?vue&type=script&lang=js"
export * from "./PackagingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports